import { render, staticRenderFns } from "./OfficialTwitterRecommend.vue?vue&type=template&id=62ae4d80&scoped=true&"
import script from "./OfficialTwitterRecommend.vue?vue&type=script&lang=js&"
export * from "./OfficialTwitterRecommend.vue?vue&type=script&lang=js&"
import style0 from "./OfficialTwitterRecommend.vue?vue&type=style&index=0&id=62ae4d80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62ae4d80",
  null
  
)

export default component.exports